import { TicketsModuleLayout } from "@features/tickets/components/TicketsModuleLayout";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Ticket } from "lucide-react";

export const Route = createFileRoute("/_app/tickets")({
  loader: requirePermission(PERMISSIONS.TICKETS.TICKETS.VIEW),
  staticData: {
    title: "Tickets",
    icon: Ticket,
    tab_icon: Ticket,
    permission: PERMISSIONS.TICKETS.TICKETS.VIEW,
    section: "Tickets",
    order: 15,
    description: "Système de tickets",
    module: "tickets",
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: TicketsModuleLayout,
});
